<template>
  <div>
    <pxkeji-rightHeader />
    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="子站集合">
              <a-select show-search :filter-option="filterOption" mode="multiple" v-model="where.keyword.dataZone"
                allowClear @change="changeDataZone">
                <a-select-option :value="subinfo.id" v-for="(subinfo, index) in where.subsites"
                  :key="index + '--' + subinfo.name">{{ subinfo.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单编号">
              <a-input placeholder="请输入" v-model="where.keyword.id" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户">
              <a-input placeholder="用户名/姓名/手机号/身份证号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单状态">
              <a-select v-model="where.keyword.status" placeholder="请选择" allowClear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">待支付</a-select-option>
                <a-select-option value="5">已完成</a-select-option>
                <a-select-option value="6">已取消</a-select-option>
                <a-select-option value="7">已退款</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="所在地区">
              <a-cascader :options="areas" placeholder="请选择所在地区" change-on-select @change="onAreachange"
                :default-value="areaList" :fieldNames="{ label: 'name', value: 'name', children: 'children' }" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="单位名称">
              <a-input placeholder="请输入" v-model="where.keyword.company" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户组">
              <a-select :disabled="statusList.groupDisableStatus" show-search v-model="where.keyword.groupId"
                :filter-option="filterOption" allowClear @change="groupChanged">
                <a-select-option :value="info.id" v-for="(info, index) in grouplist" :key="index">{{ info.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="主管部门">
              <a-select :disabled="statusList.adminStatus" show-search v-model="where.keyword.administration"
                :filter-option="filterOption" allowClear @change="administrationChanged">
                <a-select-option :value="info.itemName" v-for="(info, index) in administrationList" :key="index">{{
                  info.itemName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="支付类型">
              <a-cascader v-model="where.payMethod" :options="baseConfig.pay_method_cast"
                :fieldNames="{ label: 'title', value: 'label', children: 'children' }" @change="paymentMethodChanged"
                change-on-select expandTrigger="hover" placeholder="请选择支付方式" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="付款时间">
              <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onPayTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="下单时间">
              <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onAddTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="退款时间">
              <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onRefundTimeChange" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
            <!-- v-btnlimit="'订单管理-导出'" -->
            <!-- <a-button type="primary" :style="{ marginLeft: '8px' }" @click="exportSearchData">导出CSV</a-button> -->
            <a-button :disabled="statusList.exportButStatus" type="primary" :style="{ marginLeft: '8px' }" v-btnlimit="'子站订单统计-导出Excel'"
              @click="exportSearchDataExcel">导出Excel</a-button>
          </a-col>
          <a-col :span="16" :style="{ textAlign: 'right' }">
            <div class="totalbox" style="margin-top: 10px;">
              <span>订单数：{{ list.pagination.total }}条</span>
              <span style="margin-left: 20px;">已支付金额：{{ sumPrice }}元</span>
              <span style="margin-left: 20px;">待支付金额：{{ sumWaitPrice }}元</span>
              <span style="margin-left: 20px;">退款金额：{{ sumRefund }}元</span>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="pxkeji-right-box">
      <a-table :columns="list.columns" rowKey="id" :pagination="list.pagination" @change="onChange"
        :dataSource="list.datas" :loading="isloading" :locale="{ emptyText: '请按需求筛选后，点击搜索' }">
        <span slot="countAccount" slot-scope="info">
          <span v-if="!info.countAccount">暂无</span>
          <a-tooltip placement="top" arrowPointAtCenter>
            <template slot="title">
              <span>点击查看详情</span>
            </template>
            <a-badge :count="info.countAccount" class="pointer" :overflowCount="9999999" @click="agentChildBox(info.id)"
              :numberStyle="{ backgroundColor: '#1890ff' }" />
          </a-tooltip>
        </span>
        <span slot="paymentMethod" slot-scope="paymentMethod">
          <a-tag v-for="(item, index) in baseConfig.pay_method_line" v-if="item.label == paymentMethod"
            :color="item.color">{{ item.title }}</a-tag>
        </span>
        <span slot="orderStatus" slot-scope="orderStatus,order">
          <a-tag v-if="orderStatus == 1" color="orange">待支付</a-tag>
          <a-tag v-else-if="orderStatus == 2" color="orange">待发货</a-tag>
          <a-tag v-else-if="orderStatus == 3" color="blue">待收货</a-tag>
          <a-tag v-else-if="orderStatus == 4" color="blue">待评价</a-tag>
          <a-tag v-else-if="orderStatus == 5" color="green">已完成</a-tag>
          <a-tag v-else-if="orderStatus == 6" color="red">已取消</a-tag>
          <a-tag v-else color="red">
            <span v-if="order.is_refund_sus == 1">
              已退款
              <span v-if="order.is_refund_complete == 1">（部分退款）</span>
              <span v-else-if="order.is_refund_complete == 2">（完整退款）</span>
            </span>
            <span v-else>退款中</span>
          </a-tag>
        </span>
<!--        <span slot="discount" slot-scope="discount">-->
<!--          {{ Number(discount) > 0 && Number(discount) < 100 ? Number(discount) + "%" : "无折扣" }} </span>-->
            <span slot="action" slot-scope="info,order">
              <pxkeji-btn name="查看" size="small" @click="showInfo(info)" type="primary" v-btnlimit="'订单管理-查看'" />
            </span>
      </a-table>
    </div>
    <a-drawer title="订单详情" :width="750" placement="right" @close="hideInfo" destroyOnClose :visible="addedit.visible">
      <Info :infos="addedit.info" @callbackMethod="save" />
    </a-drawer>
  </div>
</template>
<script>
import Info from "./components/orderInfo.vue";
const columns = [
  {
    dataIndex: "dataZoneName",
    key: "dataZoneName",
    align: "center",
    title: "站点"
  },
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "订单编号"
  },
  {
    dataIndex: "userName",
    key: "userName",
    align: "center",
    title: "会员"
  },
  /*{
    dataIndex: "phone",
    key: "phone",
    align: "center",
    title: "手机号"
  },*/
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号"
  },
  {
    dataIndex: "payprice",
    key: "payprice",
    align: "center",
    title: "支付金额"
  },
  {
    dataIndex: "totalprice",
    key: "totalprice",
    align: "center",
    title: "订单总金额"
  },
  // {
  //   dataIndex: "discount",
  //   key: "discount",
  //   align: "center",
  //   title: "折扣%",
  //   scopedSlots: { customRender: "discount" }
  // },
  {
    dataIndex: "addtime",
    key: "addtime",
    align: "center",
    title: "下单时间"
  },
  {
    dataIndex: "paytime",
    key: "paytime",
    align: "center",
    title: "支付时间"
  },
  {
    dataIndex: "paymentMethod",
    key: "paymentMethod",
    align: "center",
    title: "支付方式",
    scopedSlots: { customRender: "paymentMethod" }
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "orderStatus" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];
var that;
export default {
  name: "orderList",
  data() {
    return {
      areas: [],
      areaList: [],
      grouplist: [],
      administrationList: [], //2021 11 01
      //2021 09 28 end
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //站点
        subsites: [],
        //查询条件
        keyword: {
          dataZone: [],
          id: "",
          name: "",
          status: "",
          telephone: "",
          idCard: "",
          groupId: "",
          province: '',
          city: '',
          area: '',
          startPayTime: "",
          endPayTime: "",
          startAddTime: "",
          endAddTime: "",
          startRefundTime: "",
          endRefundTime: "",
          company: "",
          administration: "",
          paymentMethod: [],
          is_tag:3,
        },
        payMethod: []
      },
      baseConfig: {
        //层级 支付方式
        pay_method_cast: [],
        //列表 支付方式
        pay_method_line: []
      },
      selectRows: [], //选中项编号
      isloading: false,
      infoId: 0, //添加时为0，修改是为编号
      infoData: {},
      orderId: "",
      order: {},//选中的订单
      agentChildBoxShow: false,
      visible: false, //弹框
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      //统计已支付金额
      sumPrice: 0,
      //统计退款金额
      sumRefund: 0,
      //统计待支付金额
      sumWaitPrice: 0,
      statusList: {
        groupDisableStatus: true,//用户组状态控制器
        adminStatus: true,//主管部门状态控制器
        exportButStatus: true //导出按钮状态控制器
      },
    };
  },
  components: {
    Info: Info,
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.getBaseConfig();  
      this.getarea(); //2021 09 28
      this.getgrouplist();//2021 09 28
      this.getDictionaryItem(); //2021 11 01
      this.getSubsites();
      //this.GetList();
    });
  },
  methods: {
    //获取子站集合
    getSubsites() {
      this.$api.area.getAllSubsitesList().then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.where.subsites = res.data
        } else {
          that.$message.error(res.errorMsg);
        }
      })
        .catch(() => {
          that.$message.error();
        });
    },
    //子站选择项目变化
    changeDataZone(v, i) {
      this.list.datas = [];
      this.list.pagination.total = 0;
      this.where.grouplist = [];
      this.where.keyword.groupId = "";

      if (v && v.length == 1) {
        this.getgrouplist();
        this.statusList.groupDisableStatus = false;
        this.statusList.adminStatus = false;
        this.statusList.exportButStatus = false;
      } else {
        this.statusList.groupDisableStatus = true;
        this.statusList.adminStatus = true;
        this.statusList.exportButStatus = true;
      }
    },
    //获取数据字典
    getDictionaryItem() {
      this.$api.dictionaryItem.tree(23).then((res) => {
        if (res.errorCode == "0000") {
          this.administrationList = res.data;
        } else {
          this.error(res.errorMsg);
        }
      });
    },
    getBaseConfig() {
      var params = {
        configList: ['pay_method_cast', 'pay_method_line']
      }
      this.$api.baseConfig.getBaseConfig(params).then(
        res => {
          if (res.errorCode == that.$msg.responseCode.success) {
            this.baseConfig = res.data;
          } else {
            this.error(res.errorMsg);
          }
        }
      );
    },
    administrationChanged(v) {
      this.where.keyword.administration = v;
    },
    onPayTimeChange(date, dateString) {
      this.where.keyword.startPayTime = dateString[0];
      this.where.keyword.endPayTime = dateString[1];
    },
    onAddTimeChange(date, dateString) {
      this.where.keyword.startAddTime = dateString[0];
      this.where.keyword.endAddTime = dateString[1];
    },
    onRefundTimeChange(date, dateString) {
      this.where.keyword.startRefundTime = dateString[0];
      this.where.keyword.endRefundTime = dateString[1];
    },
    paymentMethodChanged(v) {
      that.where.keyword.paymentMethod = []
      if (v.length > 1) {
        this.where.keyword.paymentMethod = [v[1]]
      } else if (v.length == 1) {
        this.baseConfig.pay_method_cast.forEach(function (e) {
          if (e['label'] == v[0]) {
            e['children'].forEach(function (item) {
              that.where.keyword.paymentMethod.push(item['label']);
            })
          }
        })
      }
    },
    onAreachange(v) {
      if (v[0]) {
        this.where.keyword.province = v[0];
      } else {
        this.where.keyword.province = '';
      }
      if (v[1]) {
        this.where.keyword.city = v[1];
      } else {
        this.where.keyword.city = '';
      }
      if (v[2]) {
        this.where.keyword.area = v[2];
      } else {
        this.where.keyword.area = '';
      }
    },
    getarea() {
      this.areas = this.$api.city.city;
    },
    groupChanged(v) {
      this.where.keyword.groupId = v; //2021 09 28
    },
    getgrouplist() {
      this.$api.usergroup
        .getAll()
        .then(res => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.grouplist = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.error();
        });
    },
    // 2021 10 22 start
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 2021 10 22 end
    // 2021 09 28 end
    toggle() {
      this.expand = !this.expand;
    },
    showCourse(id, order) {
      this.orderId = id;
      this.order = order;
    },
    //导出搜索数据
    exportSearchData() {
      window.location.href = this.$api.order.exportOrderData(this.where.keyword);
    },
    //导出Excel搜索数据
    exportSearchDataExcel() {
      window.location.href = this.$api.order.exportOrderDataExcel(this.where.keyword);
    },
    GetList() {
      //获取用户列表
      this.isloading = true;
      this.clearRows();
      var dataZone = this.where.keyword.dataZone;
      this.$api.order
        .getOrderListByDataZone(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.id,
          (this.where.keyword.name == "" ? null : this.where.keyword.name),
          this.where.keyword.status,
          1,
          this.where.keyword.province,
          this.where.keyword.city,
          this.where.keyword.area,
          this.where.keyword.groupId,
          this.where.keyword.company,
          this.where.keyword.startPayTime,
          this.where.keyword.endPayTime,
          this.where.keyword.startAddTime,
          this.where.keyword.endAddTime,
          this.where.keyword.administration,
          this.where.keyword.paymentMethod,
          this.where.keyword.startRefundTime,
          this.where.keyword.endRefundTime,
          dataZone.join(","),
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
            this.sumPrice = res.data.sumPrice;
            this.sumWaitPrice = res.data.sumWaitPrice;
            this.sumRefund = res.data.sumRefund;
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    refresh() {
      this.GetList();
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    hideInfo() {
      //this.visible = false;
      this.addedit.visible = false;
    },
    showInfo(info) {
      //打开弹出框
      this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>
<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>
